// Mock data for MSGG website

export const products = {
  automovel: [
    {
      id: 1,
      name: "Tinta Auto",
      description: "Lisos, Metalizados, Pérolas e entre outras opções",
      category: "Tintas Automóveis"
    },
    {
      id: 2,
      name: "Tintas Moto",
      description: "Lisos, Metalizados, Pérolas e entre outras opções",
      category: "Tintas Motociclos"
    },
    {
      id: 3,
      name: "Vernizes Auto 2K",
      description: "Acabamento brilhante de alta resistência e durabilidade",
      category: "Vernizes"
    },
    {
      id: 4,
      name: "Massas de Polir/Polish/Ceras",
      description: "Produtos para polimento e proteção de superfícies",
      category: "Polimento"
    },
    {
      id: 5,
      name: "Betumes e Primários",
      description: "Preparação e nivelamento de superfícies",
      category: "Preparação"
    },
    {
      id: 6,
      name: "Afinação de Cor Personalizada",
      description: "Cor exata do seu veículo com tecnologia avançada",
      category: "Afinação"
    },
    {
      id: 7,
      name: "Afinação Simples com Espectrofotômetro",
      description: "Leitura precisa para correspondência perfeita de cor",
      category: "Afinação"
    },
    {
      id: 40,
      name: "Mais Opções",
      description: "Consulte-nos para outros produtos e serviços automóveis",
      category: "Consulta"
    }
  ],
  construcao: [
    {
      id: 8,
      name: "Tintas Interiores",
      description: "Acabamento perfeito para paredes e tetos interiores",
      category: "Interiores"
    },
    {
      id: 9,
      name: "Tintas Exteriores",
      description: "Proteção duradoura contra intempéries",
      category: "Exteriores"
    },
    {
      id: 10,
      name: "Catálogos RAL/NCS/Pantone",
      description: "Ampla gama de cores e acabamentos disponíveis",
      category: "Cores"
    },
    {
      id: 11,
      name: "Preparação de Superfícies (Primários)",
      description: "Base ideal para aderência e acabamento duradouro",
      category: "Preparação"
    },
    {
      id: 12,
      name: "Isolamentos de Telhado/Terraços/Placas",
      description: "Impermeabilização e proteção de coberturas",
      category: "Isolamentos"
    },
    {
      id: 41,
      name: "Mais Opções",
      description: "Consulte-nos para outros produtos de construção civil",
      category: "Consulta"
    }
  ],
  sprays: [
    {
      id: 13,
      name: "Sprays Auto",
      description: "Soluções rápidas para retoques automóveis",
      category: "Automóvel"
    },
    {
      id: 14,
      name: "Sprays Moto",
      description: "Produtos especializados para motociclos",
      category: "Motociclos"
    },
    {
      id: 15,
      name: "Sprays com Afinação de Cor",
      description: "Cor personalizada (Mínimo 2 Unidades)",
      category: "Afinação"
    },
    {
      id: 16,
      name: "Sprays de Primário (Multisuperfícies)",
      description: "Preparação universal para diversos materiais",
      category: "Primários"
    },
    {
      id: 17,
      name: "Sprays Metalomecânica",
      description: "Produtos industriais para superfícies metálicas",
      category: "Industrial"
    },
    {
      id: 18,
      name: "Spray de Verniz",
      description: "Acabamento protetor e brilhante",
      category: "Vernizes"
    },
    {
      id: 42,
      name: "Mais Opções",
      description: "Consulte-nos para outros tipos de sprays",
      category: "Consulta"
    }
  ],
  acessoriosAuto: [
    {
      id: 19,
      name: "Cábine de Pintura",
      description: "Equipamento profissional para trabalhos de qualidade",
      category: "Equipamento"
    },
    {
      id: 20,
      name: "Pistolas",
      description: "Pistolas de pintura profissionais de várias marcas",
      category: "Equipamento"
    },
    {
      id: 21,
      name: "Material Técnico de Polimento",
      description: "Máquinas, Boinas, Pratos e acessórios",
      category: "Polimento"
    },
    {
      id: 22,
      name: "Compressores",
      description: "Compressores de ar para uso profissional",
      category: "Equipamento"
    },
    {
      id: 23,
      name: "Filtros",
      description: "Filtros para cábines e sistemas de pintura",
      category: "Consumíveis"
    },
    {
      id: 24,
      name: "Fatos de Pintura",
      description: "Proteção individual para trabalhos de pintura",
      category: "Proteção"
    },
    {
      id: 25,
      name: "Fitas",
      description: "Fitas de máscara de alta precisão",
      category: "Consumíveis"
    },
    {
      id: 26,
      name: "Máscaras",
      description: "Proteção respiratória profissional",
      category: "Proteção"
    },
    {
      id: 27,
      name: "Luvas",
      description: "Luvas de proteção para pintura",
      category: "Proteção"
    },
    {
      id: 28,
      name: "Lixas e Discos",
      description: "Abrasivos de várias granulometrias",
      category: "Consumíveis"
    },
    {
      id: 29,
      name: "Mais Opções",
      description: "Consulte-nos para outros produtos e acessórios",
      category: "Consulta"
    }
  ],
  acessoriosConstrucao: [
    {
      id: 30,
      name: "Rolos",
      description: "Rolos de pintura para diversos acabamentos",
      category: "Aplicação"
    },
    {
      id: 31,
      name: "Trinchas",
      description: "Pincéis profissionais de várias medidas",
      category: "Aplicação"
    },
    {
      id: 32,
      name: "Extensivos",
      description: "Extensões para rolos e ferramentas",
      category: "Aplicação"
    },
    {
      id: 33,
      name: "Fita de Pintor",
      description: "Fitas de máscara para acabamentos perfeitos",
      category: "Consumíveis"
    },
    {
      id: 34,
      name: "Proteções",
      description: "Plásticos e lonas de proteção",
      category: "Proteção"
    },
    {
      id: 35,
      name: "Proteções de Mobiliário e Chão",
      description: "Coberturas especializadas para interiores",
      category: "Proteção"
    },
    {
      id: 36,
      name: "Fatos de Pintura",
      description: "Vestuário de proteção individual",
      category: "Proteção"
    },
    {
      id: 37,
      name: "Luvas",
      description: "Luvas de proteção para trabalhos de pintura",
      category: "Proteção"
    },
    {
      id: 38,
      name: "Lixas",
      description: "Lixas manuais de diversas granulometrias",
      category: "Consumíveis"
    },
    {
      id: 39,
      name: "Mais Opções",
      description: "Consulte-nos para outros produtos e acessórios",
      category: "Consulta"
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "CMV Cozinhas",
    company: "",
    text: "Profissionais, tal como esperado, da definição de profissionais, sempre simpáticos. Material de alta qualidade. Solução para qualquer problema. Assistência para os equipamentos que vendem e sabem sempre do que estão a falar. Loja altamente recomendável.",
    rating: 5
  },
  {
    id: 2,
    name: "Paulo Freitas",
    company: "",
    text: "Excelente casa de tintas!! Preço acessíveis, material de qualidade. Atendimento 5 estrelas pessoas super prestáveis esclarecem qualquer dúvida. Recomendo muito!",
    rating: 5
  },
  {
    id: 3,
    name: "José Miguel",
    company: "",
    text: "Loja com tudo de A a Z para fazer uma pintura no carro, ou na casa.",
    rating: 5
  },
  {
    id: 4,
    name: "Domingos Ambrósio",
    company: "",
    text: "Sempre disponíveis para ajudar. Tintas de alta qualidade. Sempre prestaveis. 5 estrelas.",
    rating: 5
  },
  {
    id: 5,
    name: "Daniel Miguel",
    company: "",
    text: "Serviço impecável! Prestáveis e sempre com boa disposição.",
    rating: 5
  },
  {
    id: 6,
    name: "Maria do Rosário Ferreira",
    company: "",
    text: "Excelente serviço ao cliente. Simpatia e competência. Ampla gama de produtos. Recomendo.",
    rating: 5
  },
  {
    id: 7,
    name: "Pedro C.",
    company: "",
    text: "Excelente serviço, profissional!",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "Fazem tintas personalizadas?",
    answer: "Sim! Dispomos de tecnologia de ponta, incluindo Espectrofotómetro, que nos permite criar a cor exata que necessita. Seja para repintura automóvel ou construção civil, garantimos correspondência perfeita de cores com precisão profissional."
  },
  {
    id: 2,
    question: "Fazem entregas ao domicílio?",
    answer: "Sim, realizamos entregas rápidas em toda a região de Lisboa e arredores. Para encomendas de maior volume, contacte-nos para saber os prazos de entrega."
  },
  {
    id: 3,
    question: "Têm assessoria técnica?",
    answer: "Sim, a nossa equipa especializada está disponível para aconselhamento técnico sobre escolha de produtos, aplicação e melhores práticas. Contacte-nos por telefone ou visite a nossa loja."
  },
  {
    id: 4,
    question: "Como solicitar um orçamento?",
    answer: "Pode solicitar orçamento através do formulário no nosso website, por telefone (+351 219 673 174) ou por email (geral@mariosgomes.com). Responderemos com a maior brevidade possível."
  },
  {
    id: 5,
    question: "Têm produtos em stock?",
    answer: "Mantemos um vasto stock de todas as marcas que representamos. Para produtos específicos ou grandes quantidades, recomendamos contacto prévio para confirmar disponibilidade."
  },
  {
    id: 6,
    question: "Vendem a particulares ou só a profissionais?",
    answer: "Vendemos tanto a profissionais como a particulares. Todos os clientes beneficiam da nossa experiência e aconselhamento especializado."
  },
  {
    id: 7,
    question: "Qual é o horário de funcionamento?",
    answer: "Estamos abertos de segunda a sexta-feira das 9:00h às 13:00h e das 14:00h às 18:00h. Aos sábados das 9:00h às 13:00h. Encerramos aos domingos e feriados."
  }
];

export const brands = [
  {
    id: 1,
    name: "CIN",
    logo: "https://images.seeklogo.com/logo-png/3/1/cin-logo-png_seeklogo-30411.png",
    description: "Líder em tintas decorativas em Portugal"
  },
  {
    id: 2,
    name: "Duquebel",
    logo: "https://customer-assets.emergentagent.com/job_msgg-paints/artifacts/2vycgc8k_duquebel.jpg",
    description: "Referência em tintas e vernizes"
  },
  {
    id: 3,
    name: "mipa",
    logo: "https://www.mipa.com.au/fileadmin/mipa/images/service/downloads/logos/preview-logo-mipa.png",
    description: "Especialista em tintas automotivas"
  },
  {
    id: 4,
    name: "SPRINT",
    logo: "https://customer-assets.emergentagent.com/job_msgg-paints/artifacts/vectqpi2_ChatGPT%20Image%20Nov%203%2C%202025%2C%2008_17_24%20PM.png",
    description: "Inovação em produtos automotivos"
  },
  {
    id: 5,
    name: "Q1",
    logo: "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/9juglk9r_Q1.jpg",
    description: "Soluções premium de masking"
  },
  {
    id: 6,
    name: "SAGOLA",
    logo: "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/7uategf7_SAGOLA.png",
    description: "Equipamento profissional de pintura"
  },
  {
    id: 7,
    name: "Soudal",
    logo: "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/vc5e7n1c_soudal-hr.jpg",
    description: "Especialista em selantes e adesivos"
  },
  {
    id: 8,
    name: "Cartec",
    logo: "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/uylfralq_Square_Logo_e805b9ab-aa74-41e0-afd6-ff5cb1a3b9ba_592x.webp",
    description: "Produtos de cuidado automotivo"
  },
  {
    id: 9,
    name: "Werku",
    logo: "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/dofupigw_werku_logo.png",
    description: "Ferramentas e equipamentos profissionais"
  },
  {
    id: 10,
    name: "3M",
    logo: "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/2sfy4w8l_3M_wordmark.svg.png",
    description: "Líder global em soluções inovadoras"
  },
  {
    id: 11,
    name: "Anest Iwata",
    logo: "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/r7dz3von_anest-iwata-logo-sm_orig.png",
    description: "Pistolas de pintura de alta precisão"
  },
  {
    id: 12,
    name: "INDASA",
    logo: "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/w3nhqur5_INDASA.svg",
    description: "Abrasivos profissionais de qualidade"
  },
  {
    id: 13,
    name: "Tintal",
    logo: "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/4b4b8j2e_logo_news-1.jpg",
    description: "Tintas de qualidade superior"
  },
  {
    id: 14,
    name: "Tintas 2000",
    logo: "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/zi8ik6ev_LogoA%20_Prancheta%201.jpg",
    description: "Soluções profissionais de pintura"
  },
  {
    id: 15,
    name: "Motip",
    logo: "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/03k7i93a_motip-logo.jpg",
    description: "Sprays e produtos de pintura premium"
  }
];

export const aboutInfo = {
  history: "A Mário Simões Gomes & Gomes, Lda. é uma empresa familiar portuguesa com sede em Sintra, que ao longo de 35 anos de atividade se estabeleceu como referência no fornecimento de tintas e vernizes para repintura automóvel. Especialistas em soluções automotivas, a MSGG também oferece produtos de qualidade para construção civil. Com uma vasta experiência no sector, temos acompanhado a evolução tecnológica dos produtos de pintura, mantendo sempre o compromisso com a qualidade e o serviço personalizado.",
  mission: "A nossa missão é fornecer aos nossos clientes, sejam profissionais ou particulares, produtos de excelência para repintura automóvel e construção civil, aliados a um serviço de assessoria técnica especializada e entregas rápidas.",
  values: [
    "Qualidade dos produtos",
    "Serviço personalizado",
    "Assessoria técnica especializada",
    "Entregas rápidas e eficientes",
    "Variedade e disponibilidade",
    "Compromisso com o cliente"
  ]
};

export const storeImages = [
  "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/hek1lxmz_Instalac%CC%A7o%CC%83es%20Ma%CC%81rio%20Simo%CC%83es%20Gomes%20%26%20Gomes.jpeg",
  "https://customer-assets.emergentagent.com/job_6f3e04b3-4e65-4f2f-ab62-cc281e93c9c6/artifacts/4dbjb4o5_Instalac%CC%A7o%CC%83es%20Ma%CC%81rio%20Simo%CC%83es%20Gomes%20%26%20Gomes%201.jpeg"
];

export const contactInfo = {
  phone: "+351 219 673 174",
  email: "geral@mariosgomes.com",
  address: "Av. Combatentes do Ultramar, Arm. A - Lameiras, 2715-776 Terrugem",
  schedule: "Segunda a Sexta: 8h30 - 18h00 | Sábado: 9h00 - 13h00",
  coordinates: {
    lat: 38.8133,
    lng: -9.3633
  }
};